export const SUBMIT_LANDINGPAGE = "SUBMIT_LANDINGPAGE"
export const UPDATE_REQUEST_VALUE = "UPDATE_REQUEST_VALUE"
export const GET_LANDINGPAGE_DETAIL = "GET_LANDINGPAGE_DETAIL"
export const GET_LANDINGPAGE_DETAIL_LOADING = "GET_LANDINGPAGE_DETAIL_LOADING"
export const CLEAR_LANDINGPAGE_DETAIL = "CLEAR_LANDINGPAGE_DETAIL"
export const UPDATE_LANDINGPAGE_IMG_ECM = "UPDATE_LANDINGPAGE_IMG_ECM"
export const UPDATE_LANDINGPAGE_SAVE_LOADING = "UPDATE_LANDINGPAGE_SAVE_LOADING"